/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locallogin_Signingout2Inputs */

const en_locallogin_signingout2 = /** @type {(inputs: Locallogin_Signingout2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signing out…`)
};

/**
* | output |
* | --- |
* | "Signing out…" |
*
* @param {Locallogin_Signingout2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const locallogin_signingout2 = /** @type {((inputs?: Locallogin_Signingout2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locallogin_Signingout2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_locallogin_signingout2(inputs)
});
export { locallogin_signingout2 as "localLogin_signingOut" }